import React from "react";

const StoreIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_7479)">
      <path
        d="M18.3335 16.6665V18.3332H1.66683V16.6665H2.50016V11.0348C1.98714 10.6924 1.56659 10.2286 1.27585 9.68464C0.985102 9.14066 0.833156 8.53331 0.833497 7.9165C0.833497 7.22734 1.02016 6.56317 1.361 5.99734L3.621 2.08317C3.69414 1.95649 3.79933 1.85129 3.92601 1.77815C4.05269 1.70501 4.19639 1.66651 4.34266 1.6665H15.6585C15.8048 1.66651 15.9485 1.70501 16.0752 1.77815C16.2018 1.85129 16.307 1.95649 16.3802 2.08317L18.6318 5.98484C19.129 6.81056 19.2888 7.79612 19.078 8.73662C18.8672 9.67713 18.3021 10.5002 17.5002 11.0348V16.6665H18.3335ZM4.82433 3.33317L2.79683 6.844C2.59981 7.33079 2.5939 7.87403 2.78027 8.36499C2.96665 8.85595 3.33156 9.25841 3.80198 9.49183C4.2724 9.72525 4.81362 9.7724 5.31731 9.62385C5.82101 9.4753 6.25003 9.142 6.5185 8.69067C6.79766 7.99317 7.78516 7.99317 8.06516 8.69067C8.21958 9.07768 8.4865 9.4095 8.83144 9.64326C9.17637 9.87701 9.58348 10.002 10.0002 10.002C10.4168 10.002 10.824 9.87701 11.1689 9.64326C11.5138 9.4095 11.7808 9.07768 11.9352 8.69067C12.2143 7.99317 13.2018 7.99317 13.4818 8.69067C13.59 8.95688 13.752 9.19784 13.9578 9.3984C14.1635 9.59896 14.4086 9.7548 14.6774 9.8561C14.9463 9.95741 15.2333 10.002 15.5202 9.98707C15.8072 9.97215 16.0879 9.89802 16.3448 9.76936C16.6018 9.6407 16.8293 9.46028 17.0131 9.23945C17.197 9.01862 17.3331 8.76214 17.4131 8.48615C17.493 8.21016 17.515 7.92061 17.4776 7.63571C17.4403 7.35082 17.3444 7.07673 17.196 6.83067L15.1752 3.33317H4.82516H4.82433Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_7479">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default StoreIcon;
